module.exports = __webpack_public_path__ + "static/golf-1d4ce8edf482619eeca4469bbff2d287.jpg";